import React from 'react';
import styled from 'styled-components/macro';
import { CircularProgress, Typography } from '@material-ui/core';

interface IProps {
  message?: string;
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%;
`;

const LoadingSpinner: React.FC<IProps> = ({ message = 'Loading' }: IProps) => {
  return (
    <Root>
      <CircularProgress color="primary" size={80} />
      <Typography variant="h3" component="span">
        {message}
      </Typography>
    </Root>
  );
};

export default LoadingSpinner;
